import React, { useContext } from "react";
import ReactPlayer from "react-player";

import "./index.css";
import { RegisterButton } from "./styledComponents";
import themeContext from "../../themeContext/themeContext";

const VideoContainer = () => {
  const { isDarkMode } = useContext(themeContext);

  return (
    <div className="video-container" id="intro" isDarkMode={true}>
      <div className="video-section">
        <h2 className={`video-header ${isDarkMode ? "dark-mode" : ""}`}>
          Introduction Video in Hindi
        </h2>
        <div className="video-wrapper">
          <ReactPlayer
            url="https://youtu.be/EjxS_yPqnN8"
            className="video"
            width="100%"
            height="100%"
            controls
          />
        </div>
      </div>
      <div className="button-section">
        <RegisterButton type="button" isDarkMode={isDarkMode}>
          <a
            href="https://forms.visme.co/formsPlayer/y40z7jnr-advanced-slot-booking"
            target="_blank"
            rel="noreferrer"
          >
            Advance Slot Booking
          </a>
        </RegisterButton>

        <RegisterButton type="button" isDarkMode={isDarkMode}>
          <a
            href="https://surveyheart.com/form/664a19f0494988410f38340f"
            target="_blank"
            rel="noreferrer"
          >
            Register Your Slot now
          </a>
        </RegisterButton>
      </div>
    </div>
  );
};

export default VideoContainer;
